export default [
  'top',
  'right',
  'bottom',
  'left',
  'width',
  'minWidth',
  'maxWidth',
  'height',
  'minHeight',
  'maxHeight',
  'margin',
  'position',
  'display',
  'zIndex',
  'filter',
  'cursor',
  'transitionDuration'
];
